import React from "react";

enum Screen
{
    Connect = "connect",
    Menu = "menu",
    WeighIn = "weigh-in",
    JustLift = "just-lift",
}

type ScreenContext = [
    Screen,
    (screen: Screen) => void,
];

const context = React.createContext<ScreenContext>(null);

export default context;

export {
    Screen,
};
